import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { ConfirmNecessityDialogComponent } from './confirm-necessity-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    ConfirmNecessityDialogComponent,
  ],
  declarations: [
    ConfirmNecessityDialogComponent,
  ],
  providers: [],
})
export class ConfirmNecessityDialogModule { }
